import { galleryState as state } from './galleryState';
import { GTMTrack } from '@utils/dataLayer';

export const galleryObserveActiveItem = () => {
  const elements = document.querySelectorAll('[data-gallery-item-position]');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const value = entry.target.getAttribute(`data-gallery-item-position`);

          if (state.getIsMobile()) {
            state.setActiveItem(parseInt(value as string) + 1);

            GTMTrack('gallery_scroll', {
              gallery: { position: state.getActiveItem() },
            });
          }

          /* VPPlayer - hack zobrazit položku s přehrávačem, až když je ve viewportu,
          aby se neodesílaly GTM eventy player_play
          TODO: odstranit až bude https://cncenter.atlassian.net/browse/FEG-1287
          a volání v dynamicBehaviourUpToDevice() podmínit pouze pro mobil
        */
          {
            const activeElement: HTMLDivElement | null = document.querySelector(
              `[data-gallery-item-position="${value as string}"]`
            );

            if (activeElement) {
              // Načíst player
              const videoElement: HTMLElement | null =
                activeElement.querySelector('[data-video-hash]');

              // Zobrazit element
              if (videoElement) videoElement.style.display = 'block';
            }
          }
        }
      });
    },
    { threshold: 0.7 }
  );
  elements.forEach((element) => {
    observer.observe(element);
  });
};
